'use strict';

exports.__esModule = true;
exports.buildTagByValueAndIdentifier = buildTagByValueAndIdentifier;
exports.buildTagByValueAndSchema = buildTagByValueAndSchema;

var _TagSchemas = require('../../types/TagSchemas');

var _isEmpty = require('../../utils/is-empty');

function buildTagByValueAndIdentifier(value, identifier) {
  var tagSchema = _TagSchemas.TAG_SCHEMAS[identifier];
  return buildTagByValueAndSchema(value, tagSchema);
}

function buildTagByValueAndSchema(value, tagSchema) {
  if ((0, _isEmpty.isEmpty)(tagSchema)) {
    return {};
  }
  var tag = {
    type: tagSchema.type
  };
  if (tagSchema.props) {
    tag.props = Object.assign({}, tagSchema.props);
  }

  var _tagSchema$setValue = tagSchema.setValue(tag, value),
      isValid = _tagSchema$setValue.isValid;

  return isValid ? tag : {};
}